import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createPhoneNumberSuccess } from 'src/app/pages/add-phone-number/state/add-phone-number.actions';
import { savePhoneNumberDetailSuccess } from 'src/app/pages/phone-number-details/state/phone-number-detail.actions';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { PhoneNumberOption } from '../models/phone-number-option';
import { phoneNumberOptionActions } from './phone-number-option.actions';

export const phoneNumberOptionFeatureKey = 'phoneNumberOptions';

export type PhoneNumberOptionState = EagerSelectState<PhoneNumberOption>;

const adapter = createEagerSelectAdapter<PhoneNumberOptionState, PhoneNumberOption>({
   featureKey: phoneNumberOptionFeatureKey,
   selectId: (phoneNumber: PhoneNumberOption) => {
      return phoneNumber.phoneNumberId;
   },
});

export const phoneNumberOptionSelectors = adapter.getSelectors(filterPhoneOption);

const initialState = adapter.getInitialState();

export const phoneNumberOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   phoneNumberOptionActions.search,
   phoneNumberOptionActions.searchReset,
   phoneNumberOptionActions.loadFromApi,
   phoneNumberOptionActions.loadFromApiSuccess,
   phoneNumberOptionActions.loadFromApiFailure,
   null,
   on(createPhoneNumberSuccess, savePhoneNumberDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);

export interface PhoneSelectOption {
   displayName: string | null;
   phoneNumber: string | null;
}

export function filterPhoneOption<T extends PhoneSelectOption>(types: T[], searchText: string | null | undefined): T[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return (
            (item.displayName ? item.displayName.toUpperCase().includes(upper) : false) ||
            (item.phoneNumber ? item.phoneNumber.toUpperCase().includes(upper) : false)
         );
      });
   } else {
      return types || [];
   }
}
